"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withTextEditorState = exports.TextEditorStateProvider = void 0;
var _react = _interopRequireDefault(require("react"));
var _Logger = _interopRequireDefault(require("../../Utils/Logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var logger = new _Logger["default"]('TextEditorStateProvider');
var TextEditorContext = /*#__PURE__*/_react["default"].createContext(null);
var TextEditorStateProvider = exports.TextEditorStateProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(TextEditorStateProvider, _React$Component);
  var _super = _createSuper(TextEditorStateProvider);
  function TextEditorStateProvider() {
    var _this;
    _classCallCheck(this, TextEditorStateProvider);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      currentStyle: _this.props.defaultStyle || {},
      defaultStyle: _this.props.defaultStyle || {},
      formatDoc: function formatDoc() {},
      getStyleValues: function getStyleValues() {
        var _this$state = _this.state,
          currentStyle = _this$state.currentStyle,
          defaultStyle = _this$state.defaultStyle;
        var _ref = currentStyle || defaultStyle || {},
          fontWeight = _ref.fontWeight,
          fontStyle = _ref.fontStyle;
        return _objectSpread(_objectSpread({}, currentStyle), {}, {
          isBold: !!fontWeight && /^bold|700$/.test(fontWeight || ''),
          isItalic: !!fontStyle && fontStyle === 'italic'
        });
      },
      updateCurrentStyle: function updateCurrentStyle(styleParams) {
        return _this.setState(function (_ref2) {
          var currentStyle = _ref2.currentStyle;
          return {
            currentStyle: _objectSpread(_objectSpread({}, currentStyle), styleParams)
          };
        });
      },
      updateDefaultStyle: function updateDefaultStyle(styleParams) {
        return _this.setState(function (_ref3) {
          var defaultStyle = _ref3.defaultStyle;
          return {
            defaultStyle: _objectSpread(_objectSpread({}, defaultStyle), styleParams)
          };
        });
      },
      setFormatDocFunction: function setFormatDocFunction(formatDoc) {
        return _this.setState({
          formatDoc: formatDoc
        });
      },
      resetDefaultStyle: function resetDefaultStyle() {
        return _this.state.updateDefaultStyle(_this.props.defaultStyle);
      }
    });
    return _this;
  }
  _createClass(TextEditorStateProvider, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var defaultStyle = this.props.defaultStyle;
      if (defaultStyle !== prevProps.defaultStyle) {
        this.setState({
          defaultStyle: defaultStyle
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(TextEditorContext.Provider, {
        value: this.state
      }, this.props.children);
    }
  }]);
  return TextEditorStateProvider;
}(_react["default"].Component);
var withTextEditorState = exports.withTextEditorState = function withTextEditorState(Component) {
  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(TextEditorContext.Consumer, null, function (state) {
      return state ? /*#__PURE__*/_react["default"].createElement(Component, _extends({
        ref: ref,
        textEditorState: state
      }, props)) : logger.warn("No text editor state provided! The following component will not be rendered: ".concat(Component.name));
    });
  });
};